import './ApplicationControls.css';

interface ApplicationControlsProps {
  onPlay: () => void
  onPause: () => void
  onStop: () => void
}

/**
 * Creates a play, pause and stop button that execute the provided logic.
 */
export const ApplicationControls = ({ onPlay, onPause, onStop }: ApplicationControlsProps): JQuery => {
  const container = $('<div>')
    .attr('id', 'application_controls');

  const playerContainer = $('<div>')
    .attr('id', 'player_container')
    .addClass('ml_player');

  const playButton = $('<button>')
    .attr('id', 'playButton')
    .addClass('ml_button icon-play ml_button_success')
    .prop('disabled', true)
    .on('click', onPlay);

  const pauseButton = $('<button>')
    .attr('id', 'pauseButton')
    .addClass('ml_button icon-pause ml_button_success')
    .prop('disabled', true)
    .on('click', onPause);

  const stopButton = $('<button>')
    .attr('id', 'stopButton')
    .addClass('ml_button icon-stop')
    .prop('disabled', true)
    .on('click', onStop);

  const spinnerButton = $(`
  <div id='spinnerButton' class='ml_button player-spinner-container'>
    <div class='player-spinner'></div>
  </div>
  `);

  return container.append(
    playerContainer.append(
      spinnerButton,
      playButton,
      pauseButton,
      stopButton,
    ),
  );
};
